import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useTransactionAccess } from "../../hooks/useTransactionAccess";
import TransactionAccessModule from "../../components/modules/TransactionAccess/TransactionAccessModule";

const TransactionAccessPage = ({ user, isHideSideMenu }) => {
  const accessMethods = useTransactionAccess();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Transaction Access"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Transaction Access</h3>
            </div>

            <TransactionAccessModule
              user={user}
              {...accessMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={accessMethods.showMessage}
        message={accessMethods.message}
        isSuccess={accessMethods.isSuccess}
      />

      <LoadingSpinner loading={accessMethods.loading} />
    </>
  );
};

export default TransactionAccessPage;